import { Directive } from '@angular/core';

@Directive({
  selector: '[snDrawerNavButton]',
  host: {
    class: 'sn-drawer__nav-button',
  },
})
export class SnDrawerNavButtonDirective {
  constructor() {}
}
